import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  CreateEsignRequest,
  CreateEsignResponse,
  CreateEstampResponse,
  EstampProcurementRequest,
  DocumentStatusResponse
} from '../models/digio-interfaces';
import {
  DigioKyc_CreateESignRequest,
  DigioKyc_EstampProcurement,
  DigioKyc_GetESignStatus,
  DigioKyc_DownloadSignedDocument,
  DigioKyc_SendESignLink
} from '../GlobalVariable';

@Injectable({
  providedIn: 'root'
})
export class DigioApiService {
  private http = inject(HttpClient);

  /**
   * POST /PL/DGK/EstampProcurement
   * Procures state-mandated e-stamp certificate via Digio (NeSL / State Treasury).
   */
  createEstampRequest(payload: EstampProcurementRequest): Observable<CreateEstampResponse> {
    return this.http.post<CreateEstampResponse>(DigioKyc_EstampProcurement, payload);
  }

  /**
   * POST /PL/DGK/CreateESignRequest
   * Prepares agreement document + attaches e-stamp certificate and creates Digio e-Sign request.
   */
  createEsignRequest(payload: CreateEsignRequest): Observable<CreateEsignResponse> {
    return this.http.post<CreateEsignResponse>(DigioKyc_CreateESignRequest, payload);
  }

  /**
   * POST /PL/DGK/GetESignStatus
   * Polls or checks current signing status (borrower signature, NBFC DSC, doc completion).
   */
  getDocumentStatus(documentId: string, applicationId?: number): Observable<DocumentStatusResponse> {
    return this.http.post<DocumentStatusResponse>(DigioKyc_GetESignStatus, {
      digioDocumentId: documentId,
      digioRequestId: documentId,
      applicationId: applicationId
    });
  }

  /**
   * POST /PL/DGK/DownloadSignedDocument (returns blob)
   * Fetches the finalized, tamper-evident signed agreement PDF.
   */
  downloadSignedDocument(documentId: string, applicationId?: number): Observable<Blob> {
    return this.http.post(
      DigioKyc_DownloadSignedDocument,
      { digioDocumentId: documentId, applicationId: applicationId },
      { responseType: 'blob' }
    );
  }

  /**
   * POST /PL/DGK/SendESignLink
   * Sends the Digio eSign link to the borrower via SMS / WhatsApp / Email.
   */
  sendESignLinkToBorrower(payload: {
    applicationId: number;
    mobile?: string;
    email?: string;
    signingUrl?: string;
    borrowerName?: string;
    loanAmount?: number;
  }): Observable<any> {
    return this.http.post<any>(DigioKyc_SendESignLink, payload);
  }
}
